<template>
    <div>
        <div class="explain">
        <s-l id="explain_subscribe">En abonnant votre club, votre crédit de concours est ILLIMITE</s-l>
        </div>
         <waiting :open="openWaiting"/>
        <div v-for="choice in choices" class="subscribeItem" v-on:click="subscribe(choice)">
            
            <span v-if="choice.interval=='month'">
                <s-l id="subscribe_month" :v="choice.unit_amount/100">Abonnement Mensuel : %v € par mois </s-l>
                   
                <div class="detail">
                    <s-l id="subscribe_month_detail">Vous pourrez résiliez à tout moment. Le mois entamé sera dû.</s-l>
                </div>

            </span>
            <span v-if="choice.interval=='year'">
                <s-l id="subscribe_month" :v="choice.unit_amount/100">Abonnement Annuel : %v € par an </s-l>
                <div class="detail">
                <s-l id="subscribe_year_detail">Vous pouvez résilier votre abonnement. L'annulation sera effective à l'issu de l'année écoulée.</s-l>
                </div>
            </span>
        </div>
         <waiting :open="stripeInProgress"/>
    </div>
</template>
<style  scoped>
    .detail {
        font-style: italic;
        font-size: 16px;
        font-weight: normal;
    }
    .explain {
        font-size: 18px;
        font-weight: bolder;
        color: black;
    }
    .subscribeItem {
        padding: 25px;
        background-color: var(--bluebg);
        border: thin solid  var(--bluebg);
        color: white;
        font-size: 22px;
        font-weight: bolder;
        margin: 20px;
        border-radius: 30px;
    }
    .subscribeItem:hover {
        background-color: white;
        color: var(--bluebg);
        cursor: pointer;
    }
</style>
<script >

import subscription_fct from "@/firebase/subscription"

export default {
    props: ["club"],
    data() {
        return {
            choices: [
                {
                    unit_amount: 1000,
                    interval: "month"
                },
                {
                    unit_amount: 10000,
                    interval: "year"
                },
            ],
            stripeInProgress: false,
            openWaiting: false
        }
    },
    methods: {
        subscribe(choice) { 
            this.openWaiting = true;
            var successUrl = window.location.origin + "/club/" + this.club.id;
            var cancelUrl = window.location.origin + "/club/" + this.club.id;
            var idAuth = this.$store.getters.getUser.authId;
            this.stripeInProgress = true;
            console.log("Subscription")
            subscription_fct.object.subscribe(idAuth, this.club, choice, successUrl, cancelUrl);
        }
    },
}

</script>